import { css, type Theme } from '@emotion/react';

export const container = (theme: Theme) => css`
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 gap: 16px;
 
 border: 1px solid ${theme.colors.gray[100]};
 border-radius: 8px;

 padding: 16px;
 transition: background-color 0.5s ease;
 background-color: ${theme.colors.gray[0]};

 &:hover {
  background-color: ${theme.colors.gray[25]};
 }

 @media (min-width: ${theme.breakpoints.medium}) {
  min-width: 264px;
 }
`;

export const content = css`
 width: 100%;

 display: flex;
 justify-content: space-around;
 align-items: center;
`;

export const item = css`
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 4px;
`;

export const label = (theme: Theme) => css`
  color: ${theme.colors.gray[500]};
`;

export const statistics = css`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const lineSeparator = (theme: Theme) => css`
  width: 100%;
  border-bottom: 1px solid ${theme.colors.gray[100]};
`;

export const verticalSeparator = (theme: Theme) => css`
  height: 44px;
  border-left: 1px solid ${theme.colors.gray[100]};
`;
